// The OrionDev logo lockup (emblem + "oriondev.dev"). Size it via the
// `className` height (e.g. "h-7"); width scales automatically. Pass `mark` for
// the emblem alone, where space is tight.
//
// The logo is a raster with its inks baked in, so the dark theme gets a second
// asset (built by `npm run generate-brand`, which lifts the navy lettering to
// near-white) rather than a CSS filter, which would shift the teal too.
const Wordmark = ({ className = 'h-7', mark = false }) =>
  mark ? (
    <img src="/logo-mark.png" alt="OrionDev" draggable="false" className={`w-auto select-none ${className}`} />
  ) : (
    <picture>
      <source srcSet="/logo-dark.png" media="(prefers-color-scheme: dark)" />
      <img src="/logo.png" alt="OrionDev" draggable="false" className={`w-auto select-none ${className}`} />
    </picture>
  )

export default Wordmark
